export function formatBillingFrequency(value?: string, perFormat?: boolean): string {
  if (!value) {
    return '';
  }
  if (!perFormat) {
    switch (value.toLowerCase()) {
      case 'daily':
        return 'Daily';
        break;
      case 'weekly':
        return 'Weekly';
        break;
      case 'monthly':
        return 'Monthly';
        break;
      case 'yearly':
        return 'Yearly';
        break;
      case 'once':
      case 'one time':
      case 'one_time':
        return 'One Time';
        break;
      case 'other':
        return 'Other';
        break;
      default:
        return '';
    }
  } else {
    switch (value.toLowerCase()) {
      case 'daily':
        return 'day';
        break;
      case 'weekly':
        return 'week';
        break;
      case 'monthly':
        return 'month';
        break;
      case 'yearly':
        return 'year';
        break;
      default:
        return '';
    }
  }
}
